module.exports = __webpack_public_path__ + "static/media/quote-right.56221d47.svg";